import { CONFIG } from "~/config";
import { unsetDetail } from "~/state/detail/state";
import { store } from "~/state/store";
import { isDetailActive } from "~/util/detail";

interface ICreateMapyLogoProps {
	hidden?: boolean;
	large?: boolean;
}

export function createMapyLogo({
	hidden = false,
	large = false,
}: ICreateMapyLogoProps) {
	const logoImg = new Image();

	logoImg.classList.add("control-mapy-logo");
	logoImg.classList.add("print");
	logoImg.src = `/img/logo/com/logo-print.svg`;
	logoImg.addEventListener("click", () => {
		if (CONFIG.inFrame) {
			Mapy.Util.openInNewWindow();
		} else {
			if (isDetailActive(store.getState())) {
				store.dispatch(unsetDetail());
			}

			Mapy.getComponent("search").activate();
			Mapy.getComponent("layout").setWidth(0);
			Mapy.getComponent("history")?.save();
		}
	});

	if (hidden) {
		logoImg.classList.add("hidden");
	}

	if (large) {
		logoImg.classList.add("large");
	}

	return logoImg;
}
